// extracted by mini-css-extract-plugin
export default {"personal":"PersonalDataPage_personal__SoBCs"};